import { RichText } from "@punks/core"
import classes from "./TimelineBlock.module.css"
import React from "react"
import { CustomBox, CustomContainer } from "../../spacings"
import TimelineBlockItem from "./TimelineBlockItem"
import { TimelineItem } from "./types"
import { TwRichTextField } from "../../../root/punks/core/fields/RichTextField"

export interface TimelineBlockProps {
  title: RichText
  items: TimelineItem[]
}

const TimelineBlock = ({ title, items }: TimelineBlockProps) => {
  return (
    <>
      <CustomBox background="disabled" className="px-4 py-12 text-center">
        <TwRichTextField variant="h4" value={title} className={classes.title} />
      </CustomBox>
      <CustomContainer mobileNoGutters>
        {items.map((x, index) => (
          <TimelineBlockItem key={index} even={index % 2 === 0} item={x} />
        ))}
      </CustomContainer>
    </>
  )
}

export default TimelineBlock
